<div class="line-before"></div>  <div class="line"></div>